import { useState, useEffect, useRef } from 'react';
import { useAppStore } from "../../../../store";
import { selectCurrentUserRecord } from "../../../../store/common/userRecord/slice";

export const useChatSimulator = (nodes) => {
  const [chatHistory, setChatHistory] = useState([]);
  const [currentNode, setCurrentNode] = useState(null);
  const [parentNode, setParentNode] = useState(null);
  const messagesEndRef = useRef(null);
  const userRecord = useAppStore(selectCurrentUserRecord);

  // Load root node into simulator
  useEffect(() => {
    const root = nodes[0];
    if (root) {
      setChatHistory([
        { type: 'bot', text: root.data.question, sender: userRecord?.shopName || 'Shop' }
      ]);
      setCurrentNode(root);
      setParentNode(null);
    }
  }, [nodes, userRecord]);

  const scrollToBottom = () => {
    const messagesContainer = document.querySelector('.chat-journey-messages-container ');
    if (messagesContainer) {
      messagesContainer.scrollTop = messagesContainer.scrollHeight;
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [chatHistory]);

  const handleUserChoice = (childNode) => {
    setChatHistory(prev => [...prev, { type: 'user', text: childNode.data.question, sender: 'Customer' }]);
    setParentNode(currentNode);
    setCurrentNode(childNode);

    setTimeout(() => {
      setChatHistory(prev => [...prev, { type: 'bot', text: childNode.data.response, sender: userRecord?.shopName || 'Shop' }]);
    }, 100);
  };

  const handleBack = () => {
    setChatHistory(prev => [
      ...prev,
      { type: 'user', text: '⬅️ Back to previous', sender: 'Customer' }
    ]);
    setCurrentNode(parentNode);
    setParentNode(findParent(nodes, parentNode.key));
  };

  const findParent = (tree, targetKey) => {
    for (const item of tree) {
      if (item.children) {
        for (const child of item.children) {
          if (child.key === targetKey) {
            return item;
          }
          const found = findParent([child], targetKey);
          if (found) return found;
        }
      }
    }
    return null;
  };

  return {
    chatHistory,
    setChatHistory,
    currentNode,
    parentNode,
    messagesEndRef,
    handleUserChoice,
    handleBack
  };
}; 